import { load, trackPageview, trackGoal } from 'fathom-client';

/**
 * Fathom plugin for Vue.
 * 
 * @param {import('vue').App} app Vue application
 * @param {import('../plugin').PluginOptions} options configuration for plugin
 */

function install(app) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    siteID: '',
    disabled: false,
    settings: {}
  };
  var fathom = {};

  if (!options.disabled) {
    load(options.siteID, options.settings); // see vue-fathom.d.ts

    fathom.trackPageview = trackPageview;

    fathom.trackGoal = function (id) {
      var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      return trackGoal(id, value);
    };
  } else {
    fathom.trackPageview = function () {};

    fathom.trackGoal = function () {};
  }

  app.provide('$fathom', fathom);
}
var index = {
  install: install
};

export default index;
export { install };
